
import { PopupIds } from '../../constants/PopupIds';
import { Browsers } from '../../constants/Browsers';

let $container: JQuery = null;

function WhereIsDownload() {
    try {
        const myBrowserName = window.app.config.user_browser.name.toLowerCase();
        const isChrome = myBrowserName == Browsers.CHROME;

        if (isChrome) {
            $('.arrow_promt_download').show();
        } else {
            $('.arrow_promt_download').addClass('top_arrow_promt_download')
                .show();
        }
        setTimeout(()=>{ $('.arrow_promt_download').hide(); }, 8000);
    } catch (ex) {
        console.log(`Uh, it's error: ${ex}`);
    }
}

$(function() {
    $('#js-download_button').on('click', function() {
        window.app.game_popup_close();
        window.app.game_popup(PopupIds.DOWNLOAD_CLIENT_POPUP);
    });

    $('#download_client_popup .js-close-button').on('click', function() {
        window.app.game_popup_close();
    });

    /* - -*/
    $container = $('#download_client_screen');

    $('.js-close-button', $container).on('click', function() {
        $('#download_client_screen_buttons').show();
        $('#download_client_step').hide();
    });

    $('.download_icon_button.download', $container).on('click', function() {
        $('#download_client_screen_buttons').hide();
        $('#download_client_step').show();
    });

    $('.download_icon_button.download, .download_desktop, .download_desktop_yb').click(function() {
        /* Прячем окно с кнопками загрузки */
        window.app.game_popup_close();
        /* Показываем промт со стрелкой в зависимости от бровзера */
        WhereIsDownload();
    });
});
